import { useState, useEffect } from "react";
import Svg from "../../../../../../../../../component/common/Svg";
import Card from "../../../../../../../../../core/Card/Card";
import {
  addCustomVariableValue,
  deleteCustomVariableValue,
  editCustomVariableValue,
  getCustomVariableValueList,
} from "../../../../../../../../../store/actions/variableValueActions";
import style from "../../../../../../../../style.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getCustomVariable } from "../../../../../../../../../store/actions/variableAction";
import { Formik } from "formik";
import { addVaribleValueSchema } from "../../../../../../../../../schema/CustomValue";
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
export default function CustomVariableValue({ varibleModalData }) {
  const dispatch = useDispatch();
  const customVariableValueList = useSelector(
    (state) => state.variableValue?.customVariableValueList
  );
  const changingVaribleValue = useSelector(
    (state) => state.variableValue?.changingVaribleValue
  );
  const deletingVaribleValue = useSelector(
    (state) => state.variableValue?.deletingVaribleValue
  );
  const variables = useSelector((state) => state.variables?.customVariableData);

  const [variableOptions, setVariableOptions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const { t, i18n } = useTranslation();

  const [selectedVariableValueId, setSelectedVariableValueId] = useState("");
  const [addCustomVariableData, setAddCustomVariableData] = useState({
    su_custom_variables_id: "",
    su_survey_id: "",
    su_section_id: "",
    su_question_id: "",
    su_value: "",
  });

  //Data handling
  const fetchCustomVariable = async () => {
    dispatch(getCustomVariable(varibleModalData.surveyId));
  };

  const handleEdit = (list) => {
    setIsEdit(true);
    setSelectedVariableValueId(list.id);
    setAddCustomVariableData({
      ...addCustomVariableData,
      su_custom_variables_id: list.su_custom_variable_id,
      su_value: list.su_value,
      su_survey_id: varibleModalData.surveyId,
      su_section_id: varibleModalData.sectionId,
      su_question_id: varibleModalData.questionId,
    });
  };

  const deleteVariable = (variableId) => {
    let dataForSend = {
      su_custom_variable_value_id: variableId,
    };
    dispatch(deleteCustomVariableValue(dataForSend, successCallBack));
  };

  const fetchCustomVariableValueList = async () => {
    let dataToSend = {
      su_survey_id: varibleModalData.surveyId,
      su_section_id: varibleModalData.sectionId,
      su_question_id: varibleModalData.questionId,
      su_component_id: varibleModalData.componentID,
      su_component_type: varibleModalData.componentType,
    };
    dispatch(getCustomVariableValueList(dataToSend));
  };

  const addCustomVariable = async (data, resetForm) => {
    if (varibleModalData.componentType === "option") {
      data['su_component_id'] = varibleModalData.componentID;
      data['su_component_type'] = varibleModalData.componentType;
      dispatch(addCustomVariableValue(data, successCallBack));
      resetForm();
      setAddCustomVariableData({
        ...addCustomVariableData,
        su_value: "",
        su_custom_variables_id: "",
      });
    }
  };

  const successCallBack = () => {
    fetchCustomVariableValueList();
    setIsEdit(false);
    setAddCustomVariableData({
      ...addCustomVariableData,
      su_value: "",
      su_custom_variables_id: "",
    });
  };

  const editCustomVariable = async (data) => {
    dispatch(editCustomVariableValue(data, successCallBack));
  };

  const openDeleteModal = (variableId) => {
    setSelectedVariableValueId(variableId);
    let deleteVariableModal = document.getElementById("deleteVariableModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteVariableModal);
    if (modal && !modal._isShown) {
      modal.show();
    }
  };

  const closeDeleteModal = () => {
    let deleteVariableModal = document.getElementById("deleteVariableModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteVariableModal);
    if (modal && modal._isShown) {
      modal.hide();
    }
    setSelectedVariableValueId("");
  };

  useEffect(() => {
    if (varibleModalData) {
      fetchCustomVariable();
      fetchCustomVariableValueList();
      setAddCustomVariableData((prevData) => ({
        ...prevData,
        su_question_id: varibleModalData.questionId,
        su_section_id: varibleModalData.sectionId,
        su_survey_id: varibleModalData.surveyId,
      }));
    }
  }, [varibleModalData]);

  useEffect(() => {
    if (variables) {
      let tempArray = variables.map((variable) => {
        let label = JSON.parse(variable.su_label)[22];
        let value = variable.su_custom_variable_id;
        return { label: label, value: value };
      });
      setVariableOptions(tempArray);
    }
  }, [variables]);

  return (
    <>
      <div className="modal-body">
        <div className={"formcontainer"}>
          <div
            className={
              "formvawrapper modal-setting-medium" + " " + style.wrapper
            }
          >
            <Card view="raised" className={"formstyle p-4" + " " + style.card}>
              <div className="modal-heading">
                <h4>{t('settings.CustomVairable.linkCustom')}</h4>
              </div>

              <div className="form-wrapper mb-0">
                <div className="table-responsive table-wrapper-view">
                  <table className="table mb-4">
                    <thead>
                      <tr>
                        <th scope="col">{t('settings.CustomVairable.variableLabel')}</th>
                        <th scope="col">{t('settings.CustomVairable.variableName')}</th>
                        <th scope="col">{t('settings.CustomVairable.value')}</th>
                        <th scope="col">{t('settings.CustomVairable.action')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customVariableValueList && customVariableValueList.length > 0 ? (
                        customVariableValueList.map((list) => (
                          <tr key={list.id}>
                            <td>{JSON.parse(list.su_label)[22]}</td>
                            <td>{list.su_name}</td>
                            <td>{list.su_value}</td>
                            <td>
                              <div className="d-flex">
                                {window.modulePermissions.M11.edit == 1 && <a
                                  className="action-btn"
                                  onClick={() => handleEdit(list)}
                                >
                                  <Svg name="table-edit" />
                                </a>}
                                {window.modulePermissions.M11.del == 1 && <a
                                  className="action-btn"
                                  onClick={() => {
                                    deleteVariable(list.id);
                                  }}
                                >
                                  <Svg name="table-delete" />
                                </a>}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">{t('settings.CustomVairable.noDataFound')}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {window.modulePermissions.M11.edit == 1 && <Formik
                  initialValues={addCustomVariableData}
                  validationSchema={addVaribleValueSchema}
                  enableReinitialize
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    if (isEdit) {
                      let dataToSend = {
                        su_custom_variable_value_id: selectedVariableValueId,
                        su_custom_variables_id: values.su_custom_variables_id,
                        su_value: values.su_value,
                      };
                      editCustomVariable(dataToSend);
                    } else {
                      addCustomVariable(values, resetForm);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    resetForm,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="add-variable-wrapper">
                        <div className="modal-heading">
                          <h4>
                            {isEdit ? t('survey.builder.edit') : t('survey.stages.add')}{" "}
                            {t('settings.CustomVairable.variable')}
                          </h4>
                        </div>
                        <div className="row">
                          <div className="col-md-12 position-relative">
                            <div className="form-group mb-3">
                              <label>{t('settings.CustomVairable.selectVariable')}</label>
                              <select
                                className={`form-select ${errors.su_custom_variables_id && touched.su_custom_variables_id ? 'is-invalid' : ''}`}
                                name="su_custom_variables_id"
                                onChange={handleChange}
                                value={values.su_custom_variables_id}
                              >
                                <option value="">
                                  {t('settings.CustomVairable.select')}
                                </option>
                                {variableOptions.map((option, index) => (
                                  <option value={option.value} key={index}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              {errors.su_custom_variables_id && touched.su_custom_variables_id && (
                                <div className="validation-msg">
                                  {errors.su_custom_variables_id}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-12 position-relative">
                            <div className="form-group mb-3">
                              <label>{t('settings.CustomVairable.enterValue')}</label>
                              <textarea
                                name="su_value"
                                onChange={handleChange}
                                value={values.su_value}
                              ></textarea>
                               {errors.su_value && touched.su_value && (
                                <div className="validation-msg">
                                  {errors.su_value}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="button-wrap d-flex justify-content-end mb-0">
                          <button
                            type="button"
                            className="btn btn-bordered"
                            data-bs-dismiss="modal"
                            onClick={() => resetForm()}
                          >
                            {t('settings.CustomVairable.cancel')}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary  ms-3"
                          >
                            {changingVaribleValue ? (
                              <>
                                <span
                                  className="white-spinner spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="visually-hidden">
                                  {t('settings.CustomVairable.loading')}
                                </span>
                              </>
                            ) : (
                              t('settings.CustomVairable.save')
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>}
              </div>
            </Card>
          </div>
        </div>
      </div>
      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteVariableModal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-sm" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t('settings.CustomVairable.deleteVariable')}</h3>
                        <p>{t('settings.CustomVairable.areYouSure')}</p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered"
                          onClick={() => {
                            closeDeleteModal();
                          }}
                        >
                          {t('settings.CustomVairable.cancel')}
                        </button>
                        <button
                          type="button"
                          className="btn btn-delete ms-3"
                          onClick={() => deleteVariable()}
                        >
                          {deletingVaribleValue ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">
                                {t('settings.CustomVairable.loading')}
                              </span>
                            </>
                          ) : (
                            t('settings.CustomVairable.confirmDelete')
                          )}
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
